import { render } from "./LeftHeadline.vue?vue&type=template&id=ea553c94&scoped=true"
import script from "./LeftHeadline.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftHeadline.vue?vue&type=script&setup=true&lang=js"

import "./LeftHeadline.vue?vue&type=style&index=0&id=ea553c94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea553c94"],['__file',"src/components/Ui/LeftHeadline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea553c94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea553c94', __exports__)) {
    api.reload('ea553c94', __exports__)
  }
  
  module.hot.accept("./LeftHeadline.vue?vue&type=template&id=ea553c94&scoped=true", () => {
    api.rerender('ea553c94', render)
  })

}


export default __exports__